import React, {useState, useEffect} from 'react'
import SubHeader from '../general/SubHeader'

const Blogs = () => {
    const [blogs, setBlogs] = useState([]);

    useEffect(() => {
        const fetchBlogs = async () => {
            try {
                const response = await fetch('http://localhost:3002/api/get-blogs');
                const data = await response.json();

                if (response.ok) {
                    setBlogs(data);
                } else {
                    console.error('Failed to fetch blogs', data);
                }
            } catch (error) {
                console.error('Error while fetching sites:', error);
            }
        };

        fetchBlogs();
    }, []);


    const formatDate = (dateString) => {
        const date = new Date(dateString); // Create Date object
        return date.toLocaleDateString(); // Default format is 'MM/DD/YYYY' in the browser's locale
      };


  return (
    <>
      <SubHeader message="Blogs" />

      <section className='my-5'>
                <div className='container text-center'>

                    <p className='sec-subheading'><hr /><span>Blogs</span><hr /></p>
                    <p className='sec-heading'>Recent Blogs Posted</p>

                    <div className='row mt-5'>

                        {blogs.length > 0 ? (
                            blogs.map((blog) => (
                                <>
                                    <div className='col-lg-5 col-12 my-2 px-lg-0'>
                                        <img src={`http://localhost:3002/uploads/${blog.blog_image}`} className='blog-img' alt='Blog' />
                                    </div>

                                    <div className='col-lg-7 col-12 my-2 text-start'>
                                        <div className='blog-content h-100 py-4 px-4'>
                                        <p className='fs-5 fw-bold'>{blog.blog_title}</p>
                                        <p className='text-muted para-text fst-italic'>Posted on: {formatDate(blog.posted_on)}</p>
                                        <hr />
                                        <p className='text-muted'>{blog.blog_description}</p>
                                        </div>
                                    </div>
                                </>
                            ))
                        ) : (
                            <p>No Blogs available</p>
                        )}

                    </div>
                    {/* row ends */}

                </div>
            </section>


    </>
  )
}

export default Blogs
